document.querySelectorAll('.c-home-collection .swiper').forEach((swiperElement) => {
    const rawValue = swiperElement.dataset.deskSlide ? swiperElement.dataset.deskSlide.replace(',', '.') : null;
    const deskSlide = parseFloat(rawValue) || 4;

    new Swiper(swiperElement, {
        slidesPerView: 1.4,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: deskSlide
            }
        }
    });
});